import { OrganisationDetails } from './models/OrganisationDetails';
import { BaseService } from '../base-service'

class OrganisationApi {

    async getOrganisations() {
        const path = `/api/v1/organisation/`;
        let response = await BaseService.AsyncGet(path);

        return response as OrganisationDetails[];
    }
    
    async getoAuthLink(orgnisationId: string) {
        const path = `/api/v1/clinical-details/${orgnisationId}`;
        let response = await BaseService.AsyncGet(path);
        return response;
    }

    async linkToAdditionalOrganisations() {
        const path = `/api/v1/users/link-additional-organisations`;
        let response = await BaseService.AsyncGet(path);
        return response;
    }

}


const organisationService = new OrganisationApi();

export { organisationService };
